import { deleteToken, getToken } from './cookies'
import axios from 'axios'

const apiUrl = "https://be.qriend.app/api"

const axiosClient = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'accept':'application/json',
    'Access-Control-Allow-Origin': '*'
  }
})

axiosClient.interceptors.request.use(async (config) => {
  let token = null

  token = await getToken('qriendtoken')

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  
  return config
})

axiosClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error?.response?.status === 401) {
      deleteToken('qriendtoken')
      deleteToken('user')
    }
    if (error?.response?.status === 404) {
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export default axiosClient
